module.exports = __webpack_public_path__ + "img/motorsports.184eabae.svg";